module.exports = __webpack_public_path__ + "img/YBM.bddb3541.gif";